import { useEffect, useState } from 'react'

export const LOADING_STATUS = 'loading'
export const IDLE_STATUS = 'idle'
export const READY_STATUS = 'ready'
export const ERROR_STATUS = 'error'

function useScript(url) {
  const [status, setStatus] = useState(url ? LOADING_STATUS : IDLE_STATUS)

  useEffect(() => {
    if (!url) {
      setStatus(IDLE_STATUS)
      return () => {}
    }

    let script = document.querySelector(`script[src="${url}"]`)

    if (!script) {
      script = document.createElement('script')

      script.src = url
      script.async = true
      script.setAttribute('data-status', LOADING_STATUS)

      const setAttributeFromEvent = event => {
        if (script) {
          script.setAttribute('data-status', event.type === 'load' ? READY_STATUS : ERROR_STATUS)
        }
      }

      script.addEventListener('load', setAttributeFromEvent)
      script.addEventListener('error', setAttributeFromEvent)

      if (document.readyState === 'complete') {
        document.body.appendChild(script)
      } else {
        window.addEventListener('load', () => document.body.appendChild(script), false)
      }
    } else {
      setStatus(script.getAttribute('data-status') || IDLE_STATUS)
    }

    const setStateFromEvent = event => {
      setStatus(event.type === 'load' ? READY_STATUS : ERROR_STATUS)
    }

    script.addEventListener('load', setStateFromEvent)
    script.addEventListener('error', setStateFromEvent)

    return () => {
      if (script) {
        script.removeEventListener('load', setStateFromEvent)
        script.removeEventListener('error', setStateFromEvent)
        script.remove()
      }
    }
  }, [url])

  return status
}

export default useScript
